import StatusMessage from '../../common/helpers/statusmessage.js';
import BusyButton from '../../common/helpers/busybutton.js';
import FetchHelpers from '../../common/helpers/fetchhelpers.js';
import Recaptcha from '../../common/forms/recaptcha.js';
import Forms4i from '../../common/forms/forms25.js';

const API_ENDPOINT = {
    AMPLIFY_SUBSCRIBE: '/blog/amplify/subscribe',
};

const MESSAGES = {
    Error: "There was an error processing your subscription request. Please try again.",
    Success: "Your subscription has been saved."
};

const submitButton = document.getElementById("submitEmailButton");
const forms4i = new Forms4i();
const recaptcha = new Recaptcha();

async function init() {
    forms4i.init({
        form: document.getElementById("subscribeArticles"),
        submitButton: submitButton,
        onSuccess: subscribeAmplify,
        onFailure: showError
    });
}

async function subscribeAmplify() {
    recaptcha.ready(async () => {
        try {
            BusyButton.show(submitButton);
            const actionName = document.getElementById("RecaptchaActionName").value;
            const token = await recaptcha.getToken();

            var data = {
                emailAddress: document.getElementById("Email").value,
                useRecaptcha: true,
                recaptchaAction: actionName,
                recaptchaToken: token
            };

            await sendSubscribeRequest(data);
        } catch (error) {
            showError(MESSAGES.Error);
        }
    });
};

async function sendSubscribeRequest(data) {
    try {
        const response = await fetch(API_ENDPOINT.AMPLIFY_SUBSCRIBE, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'fetch',
                "__RequestVerificationToken": FetchHelpers.headerToken,
                "RequestVerificationToken": FetchHelpers.headerToken
            }
        });

        if (!response.ok) throw new Error(`Error processing subscription request: ${response.statusText}`);

        const responseJSON = await response.json();

        if (responseJSON && responseJSON.success) {
            BusyButton.clear();
            document.getElementById("Email").value = "";
            StatusMessage.showSuccess(submitButton.parentNode, MESSAGES.Success);
        } else {
            showError(responseJSON.message || MESSAGES.Error);
        }

    } catch (error) {
        showError(MESSAGES.Error);
    }
}

function showError(message) {
    BusyButton.clear();
    StatusMessage.showError(submitButton.parentNode, message || MESSAGES.Error);
};

await init();